document.addEventListener("DOMContentLoaded", () => {

    const routes = window.routes;

    let params = new URLSearchParams(window.location.search),
    courseId = params.get('id'),
    courseName = document.querySelector('.description h1').textContent ?? '',

    csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');


    /* ######################
     * Detail Videos Handling
     * ######################
     */
    let videoTopSource = document.getElementById('video_top_source'),
        videoTopId = document.getElementById('video_top_id'),
        videoBottomSource = document.getElementById('video_bottom_source'),
        videoBottomId = document.getElementById('video_bottom_id');

    if (videoTopSource) {
        new window.SapoPlayer(
            document.getElementById("videoTop"), `https://videos.sapo.pt/${videoTopId.value}`
        );
    }

    if (videoBottomSource) {
        new window.SapoPlayer(
            document.getElementById("videoBottom"), `https://videos.sapo.pt/${videoBottomId.value}`
        );
    }

    let loadClicksData = async (event,courseId) => {
        const response = await fetch(`/courses/clicks/${courseId}`);
    }

    if(document.querySelectorAll('a[data-id]')){
        let redirectLinkElements = document.querySelectorAll('a[data-id]');
        redirectLinkElements.forEach(function(element) {
            element.addEventListener('click', event => {
                event.preventDefault();

                if(element.classList.contains('[course-ask-info]') && element.href){
                    window.location.href = element.href;
                }else{
                    const courseId = document.querySelector('[data-id]').dataset.id;

                    if (courseId) {
                        loadClicksData(event, courseId);
                    }
                }



            });

        });
    }


    /* #############
        * Report Job JS
        * #############
        */
    let submitReportCourseForm = (event) => {
        event.preventDefault();
        Ink.requireModules(['Ink.Dom.Css_1', 'Ink.Dom.Element_1'], function(InkCss, InkElement){
            let spinnerElem = Ink.i('rj-btn-spinner'),
                reportReason = Ink.i('rj-ad-report-reason'),
                obsErrorElem = Ink.i('rj-obs-error-msg'),
                reasonContainerElem = Ink.i('rj-reason-container'),
                obsContainerElem = Ink.i('rj-obs-container');
            InkCss.addClassName(spinnerElem, 'hide-all');
            InkCss.addClassName(obsErrorElem, 'hide-all');
            InkCss.addClassName(obsErrorElem, 'hide-all');
            InkCss.removeClassName(reasonContainerElem, 'error')
            InkCss.removeClassName(obsContainerElem, 'error');

            let errorReason = false,
                errorReasonContainer = Ink.i('rj-reason-error-msg'),
                errorObs = false,
                reason = reportReason.value,
                obs = Ink.i('rj-obs').value,
                courseId = Ink.i('rj-course-id-info').value;

            if (!reason) {
                errorReason = true;
            }
            if (!obs) {
                errorObs = true;
            }

            if (errorReason === true || errorObs === true) {
                if (errorReason === true) {
                    InkCss.removeClassName(errorReasonContainer, 'hide-all');
                    InkCss.addClassName(reasonContainerElem, 'error');
                }
                if (errorObs === true) {
                    InkCss.removeClassName(obsErrorElem, 'hide-all');
                    InkCss.addClassName(obsContainerElem, 'error')
                }
                return;
            }

            let postData = {
                'reason': reason,
                'obs': obs
            };

            InkCss.removeClassName(spinnerElem, 'hide-all');
            window.axios.post(`/courses/${courseId}/report`, postData)
                .then(res => {
                    document.getElementById('app').dispatchEvent(new CustomEvent("flash-custom-message", {
                        detail: { text: lang.get('popups.save_success'), type: 'success', timeout: 10000 }
                    }));
                    reason = ''; obs = '';
                    InkCss.addClassName(spinnerElem, 'hide-all');
                    document.querySelector(`#report-close-button`).click();
                }).catch(err => {
                document.getElementById('app').dispatchEvent(new CustomEvent("flash-custom-message", {
                    detail: { text: lang.get('popups.save_error'), type: 'error', timeout: 10000 }
                }));
                InkCss.addClassName(spinnerElem, 'hide-all');
            })
        });
    };

    if(document.getElementById('course-report')){
        document.getElementById('course-report').addEventListener('submit', submitReportCourseForm);
    }

    /* ######################
     * Detail Apply Button JS
     * ######################
     */
        let applyCourseFun = (event) => {
            event.preventDefault();
            let linkComponent = document.getElementsByClassName('[share-apply-dev]');
            let replyHookUrl = linkComponent[0].getAttribute("href");


            if (replyHookUrl) {
                let externalApplyModal = Ink.UI.Common.getInstance('#externalApplyModal');
                if (externalApplyModal.length > 0) {
                    externalApplyModal[0].open();
                }
            } else {
                window.location.href = replyHookUrl;
            }
        };

        let elems = document.getElementsByClassName('[share-apply-dev]');
        for (let i = 0; i < elems.length; i++) {
            elems[i].addEventListener('click', applyCourseFun);
        }
    // ####################################################
    // ####################################################


    /* ########################
     * External Apply Button JS
     * ########################
     */
    let applyExternalJob = (event) => {
        event.preventDefault();
        let externalApplyModal = Ink.UI.Common.getInstance('#externalApplyModal');
        externalApplyModal[0].dismiss();
        window.open(document.getElementById('extapp-link-info').value,'_blank');
    };
    let externalApplyElem = document.getElementById('external-apply-modal-btn');
    if (externalApplyElem) {
        document.getElementById('external-apply-modal-btn').addEventListener('click', applyExternalJob);
    }
})
